<!-- eslint-disable unicorn/no-new-array -->
<script setup lang="ts">
const { onFeedViewMounted, onFeedViewUnmounted, groupedContents, onUpdatedViewModeSettings, fileColumns } = useFeedView()
const { state: viewModeState, previewScale } = useViewMode()
const { currentRootFolder } = useNavigation()
const { isGrouping } = useViewMode()
const { isInFolderMode } = useCollectionView()

const container = useTemplateRef("container")
const { width } = useElementSize(container)
const throttledWidth = refThrottled(width, 1000 / 30)

const implicitWidth = computed(() => {
  const scale = previewScale.value
  const width = 2 ** (5 + 5 * scale)
  return width
})
const numColumns = computed(() => Math.max(1, Math.round(throttledWidth.value / implicitWidth.value)))

const previewWidth = computed(() => throttledWidth.value / numColumns.value)

onMounted(() => onFeedViewMounted())
onUnmounted(() => onFeedViewUnmounted())

watch(() => viewModeState.value.current, onUpdatedViewModeSettings)
</script>

<template>
  <collection-scroll-container vertical>
    <div class="spacer" />
    <div class="notes-container">
      <collection-folder-notes
        v-if="isInFolderMode() && currentRootFolder"
        :key="currentRootFolder.id"
        :folder="currentRootFolder.asStatic()"
      />
    </div>
    <div
      v-if="isGrouping()"
      ref="container"
      class="feed-group-list"
    >
      <collection-feed-group
        v-for="{ id, files } in groupedContents"
        :key="id"
        :group-id="id"
        :files
        :num-columns
        :preview-width
      />
    </div>
    <div
      v-else
      ref="container"
      class="flex p-0.5"
    >
      <div
        v-for="(column, key) in fileColumns(numColumns)"
        :key
        class="w-full flex flex-col"
      >
        <collection-feed-file
          v-for="(_, fileId) in column"
          :key="fileId"
          :file-id
          :preview-width
          class="group relative w-full cursor-pointer"
        />
      </div>
    </div>
  </collection-scroll-container>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.feed-group-list
  @apply flex flex-col gap-4

.spacer
  @apply pointer-events-none w-full
  @apply h-[#{$nav-h-default}] mb-[#{$nav-gap-pills}]

.notes-container
  @apply px-[#{$page-icon-p-main}] py-1
</style>
